/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Rev_Per_SignupInputs */

const en_admin_funnel_history_rev_per_signup = /** @type {(inputs: Admin_Funnel_History_Rev_Per_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue / sign-up`)
};

/**
* | output |
* | --- |
* | "Revenue / sign-up" |
*
* @param {Admin_Funnel_History_Rev_Per_SignupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_rev_per_signup = /** @type {((inputs?: Admin_Funnel_History_Rev_Per_SignupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Rev_Per_SignupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_rev_per_signup(inputs)
});
export { admin_funnel_history_rev_per_signup as "admin.funnel.history.rev_per_signup" }